import { render, staticRenderFns } from "./CategorySec.vue?vue&type=template&id=5f7f0f78"
import script from "./CategorySec.vue?vue&type=script&lang=js"
export * from "./CategorySec.vue?vue&type=script&lang=js"
import style0 from "./CategorySec.vue?vue&type=style&index=0&id=5f7f0f78&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports